<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/css/vue-popper.css";
import { mapState } from "vuex";
export default {
    name: "sub-nav",
    components: {
        Popper
    },
    props: ["parent"],
    data() {
        return {
            visible: false
        };
    },
    methods: {
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        }
    },
    computed: {
        ...mapState({
            main_menu: state => state.main_menu,
            main_menu_flat: state => state.main_menu_flat
        }),
        navItem() {
            return this.main_menu.filter(item => {
                return item.id == this.parent;
            })[0];
        },
        children() {
            return this.main_menu_flat.filter(item => {
                return item.parent == this.navItem.parent;
            });
        },
        options() {
            return this.navItem.level == 1
                ? { placement: "bottom-end" }
                : { placement: "right-start" };
        },
        linkClasses() {
            if (this.navItem.level == 1) {
                return "flex flex-row justify-between items-center flex-no-wrap";
            }
            if (this.navItem.level == 2) {
                return "flex flex-row justify-between items-center flex-no-wrap";
            }
            if (this.navItem.level == 3) {
                return "hover:bg-white hover:underline";
            }
        },
        childClasses() {},
        arrowClasses() {
            if (this.navItem.level == 1) {
                return "absolute pin-y pin-r p-2 mr-4 flex flex-col justify-center items-end z-10";
            }
            if (this.navItem.level == 2) {
                return "rotate--90 py-2";
            }
        },
        popperClasses() {
            if (this.navItem.level == 1) {
                return "text-right";
            }
            if (this.navItem.level == 2) {
                return "text-left";
            }
        },
        linkSpanClasses() {
            if (this.navItem.level == 1) {
                return "text-left leading-tight pr-4";
            }
            if (this.navItem.level == 2) {
                return "text-left leading-tight";
            }
            if (this.navItem.level == 3) {
                return "text-left leading-tight";
            }
        },
        trigger() {
            return this.$root.showNav ? "hover" : "click";
        }
    }
};
</script>

<template>
    <popper
        v-if="navItem && navItem.hasChildren"
        :trigger="trigger"
        @show="show"
        @hide="hide"
        :delay-on-mouse-out="300"
        :options="options"
        transition="fade"
    >
        <div class="popper" :class="popperClasses">
            <div class="flex flex-col">
                <a
                    v-for="item in navItem.children"
                    :href="item.url"
                    :nav-item="item"
                    :key="item.id"
                    class="no-underline text-beige-dark hover:text-black hover:bg-white relative text-sm cursor-pointer"
                    :class="linkClasses"
                    :target="item.target_new_window === true ? '_blank' : '_self'"
                >
                    <span
                        class="block pt-3 pb-4 px-1 md:p-2"
                        :class="linkSpanClasses"
                    >{{ item.title }}</span>
                    <sub-sub-nav v-if="item.hasChildren" :parent="item.id"/>
                </a>
            </div>
            <!-- <sub-nav
				v-for="item in navItem.children"
				:nav-item="item"
				:key="item.id"
            />-->
        </div>

        <button slot="reference" :class="arrowClasses" aria-label="Access submenu">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="w-4 h-4" viewBox="0 0 20 20">
                <title>Access submenu</title>
                <circle cx="10" cy="10" r="10" class="fill-current text-white"></circle>
                <path
                    class="stroke-current"
                    :class="visible ? 'text-beige-darkest' : 'text-beige'"
                    stroke-opacity="0.5"
                    stroke-width="2"
                    d="M5 7.5l5 5 5-5"
                ></path>
            </svg>
        </button>
    </popper>
    <!-- <a
        :href="navItem.url"
        class="no-underline text-beige-dark hover:text-black hover:bg-white relative text-sm font-normal"
		:class="linkClasses">

        <span class="block py-3 px-1 md:p-2" :class="linkSpanClasses" v-html="navItem.title">
        </span>

        <popper v-if="navItem.hasChildren" trigger="hover" :options="options" class="" @show="show" @hide="hide" :delay-on-mouse-out="300" transition="fade">

            <div class="popper" :class="popperClasses">
                <sub-nav
                    v-for="item in navItem.children"
                    :nav-item="item"
                    :key="item.id"
                />
            </div>

            <button slot="reference"
				:class="arrowClasses">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="w-6 h-6" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="10" class="fill-current text-white" />
                    <path class="stroke-current" :class="visible ? 'text-beige-darkest' : 'text-beige'" stroke-opacity=".5" stroke-width="2" d="M5 7.5l5 5 5-5"/>
                </svg>
            </button>

        </popper>
    </a>-->
</template>

<style>
div.popper {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}
</style>
